import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function SiteLayout() {
    const location = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [location.pathname]);

    const transparent = location.pathname === "/";
    return (
        <div className="min-h-screen bg-cream-light text-coffee font-body">
            <Navbar transparent={transparent} />
            <main>
                <Outlet />
            </main>
            <Footer />
        </div>
    );
}
